<main class="main">
    <app-breadcrumb [title]="title"></app-breadcrumb>

    <h3 class="grey-dark h1">{{ title }}</h3>

    <form class="profil bg-grey-light border-dark pb-3 mt-4 col-6" [formGroup]="profil">
        <ul>
            @for (item of data; track $index) 
            {
                <li class="profil-item">
                    <div class="col-3">{{ item.name }}</div>

                    @if(item.value)
                    {
                        <div class="col-9 bolder text-break">{{ item.value }}</div>
                    }
                    @else
                    {
                        <div class="col-9">-</div>
                    }
                </li>
            }


            <!-- <div *ngIf="!isEmailSectionVisible && !isPasswordSectionVisible">
                <button type="button" class="bg-blue white no-border save-profil" (click)="toggleEmailSection()">Modifier mon email</button>
            </div> -->
            
            <div *ngIf="!isEmailSectionVisible && !isPasswordSectionVisible">
                <button type="button" class="bg-blue white no-border save-profil" (click)="togglePasswordSection()">Modifier mon mot de passe</button>
            </div>

            
            @if(isEmailSectionVisible)
            {
                <section>
                    <li class="profil-item email-item">
                        <div class="col-4">Votre adresse email</div>
                        <input class="col-8" type="email" formControlName="email" oninput="this.value = this.value.trimStart()">
                    </li>
                    <p class="red bold offset-1" *ngIf="isSubmitted && isInvalid('email') && profil.get('email')?.errors">
                        <em>
                            <p>* L'adresse email n'est pas valide</p>
                        </em>
                    </p>
                    <li class="profil-item confirm-email-item">
                        <div class="col-4">Confirmer votre email</div>
                        <input class="col-8" type="email" formControlName="confirm_email" oninput="this.value = this.value.trimStart()">
                    </li>
                    <p class="red bold offset-1" *ngIf="isSubmitted && isInvalid('confirm_email') && profil.get('confirm_email')?.errors">
                        <em>
                            <p>* L'adresse email n'est pas valide</p>
                        </em>
                    </p>
                    <p class="red bold offset-1" *ngIf="isSubmitted && profil.hasError('emailMismatch')">
                        <em>
                            <p>* Les adresses email ne sont pas identiques</p>
                        </em>
                    </p>
                    <p class="red bold offset-1" *ngIf="isSubmitted && emailExists">
                        <em>
                            <p>* Cette adresse mail est déjà liée à un espace abonné. Veuillez en choisir une autre.</p>
                            <p>En cas de besoin, vous pouvez utiliser le <a class="blue underline cursor" (click)="goToContactPage()">formulaire de contact de la Médiation de l'eau</a></p>
                        </em>
                    </p>
                </section>
                <button type="button" class="bg-blue white no-border save-profil" (click)="submit()">Enregistrer l'adresse email</button>
            }

            @if(isPasswordSectionVisible)
            {
                <section>
                    <li class="profil-item password-item">
                        <div class="col-4">Saisissez votre mot de passe actuel</div>
                        <input class="col-8" type="password" formControlName="password">
                    </li>
                    <p class="red bold offset-1"><em><p>{{ errorMessage }}</p></em></p>

                    @if( passwordCheck )
                    {
                        <li class="profil-item password-item">
                            <div class="col-4">Nouveau mot de passe</div>
                            <input 
                                class="col-8" 
                                type="password" 
                                formControlName="new_password" 
                                [maxlength]="limit"
                                [ngClass]="profil.get('new_password')?.value.length >= limit ? 'red': ''">
                            <img class="password-icon" [src]="srcIconPassword" alt="montrer ou masquer le nouveau mot de passe" (click)="togglePasswordVisibility($event)">
                        </li>
                        <p class="red bold offset-1" *ngIf="isSubmitted && isInvalid('new_password') && profil.get('new_password')?.errors"><em><p>* La longueur du mot de passe doit être de 8 caractères au minimum</p></em></p>
                        <p class="red bold offset-1" *ngIf="profil.get('new_password')?.value.length >= limit"><em><p>Vous avez atteint la limite du nombre de caractères autorisé</p></em></p>
    
                        <li class="profil-item password-item">
                            <div class="col-4">Confirmez le mot de passe</div>
                            <input 
                                class="col-8" 
                                type="password" 
                                formControlName="confirm_password" 
                                [maxlength]="limit"
                                [ngClass]="profil.get('confirm_password')?.value.length >= limit ? 'red': ''">
                            <img class="password-icon" [src]="srcIconPassword" alt="montrer ou masquer le nouveau mot de passe" (click)="togglePasswordVisibility($event)">
                        </li>
                        <p class="red bold offset-1" *ngIf="isSubmitted && isInvalid('confirm_password') && profil.get('confirm_password')?.errors"><em><p>* La longueur du mot de passe doit être de 8 caractères au minimum</p></em></p>
                        <p class="red bold offset-1" *ngIf="profil.get('confirm_password')?.value.length >= limit"><em><p>Vous avez atteint la limite du nombre de caractères autorisé</p></em></p>
                    }

                </section>

                @if( passwordCheck )
                {
                    <button type="button" class="bg-blue white no-border save-profil" (click)="submit()">Enregistrer</button>
                }
                @else
                {
                    <button type="button" class="bg-blue white no-border save-profil" (click)="checkPassword()" [disabled]="profil.get('password')?.value?.length == 0">Vérifier</button>
                }
                <p class="red bold offset-1" *ngIf="isSubmitted && profil.getError('passwordMismatch')"><em><p>* Les mots de passe ne concordent pas</p></em></p>
            }

            @if(isEmailSectionVisible || isPasswordSectionVisible)
            {
                <button type="button" class="bg-red white no-border save-profil float-start" (click)="close()">Annuler</button>
            }
        </ul>
    </form>

</main>
